import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "month",
  "use": "month-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"month\">\n    <path fill=\"#003595\" fill-rule=\"evenodd\" d=\"M18 4.556h-.778V3h-1.555v1.556H7.889V3H6.333v1.556h-.777C4.7 4.556 4 5.256 4 6.11v12.445c0 .855.7 1.555 1.556 1.555H18c.856 0 1.556-.7 1.556-1.555V6.11c0-.855-.7-1.555-1.556-1.555zm0 14H5.556V10H18v8.556zm0-10.112H5.556V6.111H18v2.333z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol